import React from 'react';
import { Row, Col } from 'react-bootstrap';

function WorkflowReviewTab({ workflowName, stationName }) {
  return (
    <div className="vehicle-tracking-detail-height vertical-padding-10 horizontal-padding-10">
      <span className="text-xxl text-bold">Updated Workflow &amp; Station</span>
      <Row className="g-3">
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <div className="div-flex-column">
            <label
              className="form-label-section text-sm text-bold"
              htmlFor="final-workflow-name"
            >
              Select Workflow
            </label>
            <input
              id="final-workflow-name"
              className="form-input-section margin-top-5"
              type="text"
              value={workflowName}
              readOnly
            />
          </div>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <div className="div-flex-column">
            <label
              className="form-label-section text-sm text-bold"
              htmlFor="final-station-name"
            >
              Select Station
            </label>
            <input
              id="final-station-name"
              className="form-input-section margin-top-5"
              type="text"
              value={stationName}
              readOnly
            />
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default WorkflowReviewTab;
